import React, { useMemo, useState } from "react";
import {Name, Created_at, Active, Options} from "./typePropertyCol";

const useTypePropertyCols = (typeProperty, handleSetEditTypeProperty ) => {
    return useMemo(() => [
        {
            Header: "Tipo de Propiedad",
            accessor: "name",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Tipo de Propiedad Padre",
            accessor: "type_property_parent_name",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Fecha Alta",
            accessor: "create_at_f",
            filterable: false,
            Cell: (cellProps) => {
                return <Created_at {...cellProps} />;
            },
        },
        {
            Header: "Status",
            accessor: "active",
            filterable: false,
            Cell: (cellProps) => {
                return <Active {...cellProps} />;
            },
        },
        {
            Header: "Opciones",
            accessor: "options",
            filterable: false,
            Cell: (cellProps) => {
                return <Options {...cellProps} onEdit={handleSetEditTypeProperty} />;
            },
        }
    ],[]);  
}
export {useTypePropertyCols}